/**
 * SOLID Review
 * S — Strong. One concern: one of the browser's storage areas behind the storage role.
 * O — Good. Nothing here names an area; the caller hands it.
 * L — Strong. Implements `IServiceBrowserStorage` exactly.
 * I — Strong. Three operations.
 * D — Strong. The area is handed in, as a supplier.
 */
import type { IServiceBrowserStorage } from './IServiceBrowserStorage';

/**
 * ONE OF THE BROWSER'S STORAGE AREAS (frontend-infrastructure-oo P1, 2026-10-28, §28.286), reached through the supplier the
 * composition root hands it — `() => window.localStorage` — and only when an operation runs. Reading `window.localStorage`
 * itself throws where storage is disabled; resolved at call time, that throw lands in the storage object's `catch`, as it did
 * when the functions named the global, and never at boot. Under Node (the port and UML generators) it is never called.
 */
export class BrowserStorageArea implements IServiceBrowserStorage {
  constructor(private readonly area: () => Storage) {}

  getItem(key: string): string | null {
    return this.area().getItem(key);
  }

  setItem(key: string, value: string): void {
    this.area().setItem(key, value);
  }

  removeItem(key: string): void {
    this.area().removeItem(key);
  }
}
